const PropTypes = require('prop-types');
// @ vendors
const React = require('react');

// @ commons
const { formatText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');

class ChooseDate extends React.Component {
    render() {
        const { onHandleGoToPanel, onHandleToggleCalendar, isLoadingTargetDate, isLoadingContinue, disabled } = this.props;

        return (
            <div className="row mortgage-request-target-date-containter">
                <div className="col-sm-12">
                    <p className="mortgage-request-manager-view__text">
                        {formatText('mortgageRequestManager-chooseDateTextNew')}
                    </p>
                </div>
                <div className="col-sm-4 mortgage-request-target-date__space-button">
                    <OKButton
                        block
                        modifier="ghost"
                        onClick={onHandleToggleCalendar}
                        loading={isLoadingTargetDate}
                        disabled={disabled}
                    >
                        {formatText('mortgageRequestManager-chooseDateYesButtonNew')}
                    </OKButton>
                </div>
                <div className="col-sm-5 mortgage-request-target-date__space-button">
                    <OKButton block={true} modifier="secondary" onClick={onHandleGoToPanel} loading={isLoadingContinue} disabled={disabled}>
                        {formatText('mortgageRequestManager-chooseDateNoButtonNew')}
                    </OKButton>
                </div>
            </div>
        );
    }
}

ChooseDate.propTypes = {
    onHandleGoToPanel: PropTypes.func,
    onHandleToggleCalendar: PropTypes.func,
    isLoadingContinue: PropTypes.bool,
    isLoadingTargetDate: PropTypes.bool,
    disabled: PropTypes.bool
};

module.exports = ChooseDate;
